module.exports = __webpack_public_path__ + "img/dne-pay.ebd80144.png";